import React from 'react';

const SidePanelOpen = ({ width = 24, height = 24, fill = '#666666', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.5 14.8C7.5 15.0333 7.6 15.1917 7.8 15.275C8 15.3583 8.18333 15.3167 8.35 15.15L10.8 12.7C11 12.5 11.1 12.2667 11.1 12C11.1 11.7333 11 11.5 10.8 11.3L8.35 8.85C8.18333 8.68333 8 8.64167 7.8 8.725C7.6 8.80833 7.5 8.96667 7.5 9.2V14.8ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM16 19H19V5H16V19ZM14 19V5H5V19H14Z" fill={fill}/>
  </svg>
);

export default SidePanelOpen;
